// used in minDate, maxDate where we need to
// provide user with all year options
export const DEFAULT_FROM_YEAR = 1970;
export const DEFAULT_TO_YEAR = 2100;

export const dateSelectionSchema = {
  $schema: 'http://json-schema.org/draft-07/schema#',
  type: 'object',
  definitions: {
    minDate: {
      type: 'string',
      format: 'date',
      title: 'Start Date',
      dateFormat: 'yyyy-MM-dd',
    },
    maxDate: {
      type: 'string',
      format: 'date',
      dateFormat: 'yyyy-MM-dd',
      title: 'End Date',
    },
  },
  properties: {
    dateRangeLimit: {
      type: 'string',
      title: 'Date Range Configuration',
      default: 'selectRange',
      oneOf: [
        {
          const: 'disablePast',
          title: 'Only Future Dates',
        },
        {
          const: 'disableFuture',
          title: 'Only Past Dates',
        },
        {
          const: 'selectRange',
          title: 'Custom Date Range',
        },
      ],
    },
  },
  allOf: [
    {
      if: {
        properties: {
          dateRangeLimit: {
            anyOf: [
              {
                const: 'disablePast',
              },
              {
                const: 'disableFuture',
              },
            ],
          },
        },
        required: ['dateRangeLimit'],
      },
      then: {
        properties: {
          includeToday: {
            type: 'boolean',
            title: 'Include Today',
            description: 'Allow selection of the current date',
            default: true,
          },
        },
      },
    },
    {
      if: {
        properties: {
          dateRangeLimit: {
            const: 'disablePast',
          },
        },
        required: ['dateRangeLimit'],
      },
      then: {
        properties: {
          maxDate: {
            $ref: '#/definitions/maxDate',
          },
        },
      },
    },
    {
      if: {
        properties: {
          dateRangeLimit: {
            //  before today
            const: 'disableFuture',
          },
        },
        required: ['dateRangeLimit'],
      },
      then: {
        properties: {
          minDate: {
            $ref: '#/definitions/minDate',
          },
        },
      },
    },
    {
      if: {
        properties: {
          dateRangeLimit: {
            const: 'selectRange',
          },
        },
        required: ['dateRangeLimit'],
      },
      then: {
        properties: {
          minDate: {
            $ref: '#/definitions/minDate',
          },
          maxDate: {
            $ref: '#/definitions/maxDate',
          },
        },
      },
    },
  ],
};

export const dateSelectionUiSchema = {
  'ui:order': ['dateRangeLimit', 'includeToday', 'minDate', 'maxDate'],
  dateRangeLimit: {
    'ui:titleClassName': 'text-primary',
    'ui:weight': 'medium',
  },
  includeToday: {
    'ui:widget': 'ToggleWidget',
    'ua:options': {
      orientation: 'column',
    },
    'ui:titleClassName': 'text-primary',
    'ui:weight': 'medium',
    'ui:fieldLayout': [['title', 'children'], ['description']],
  },
  minDate: {
    'ui:titleClassName': 'text-primary',
    'ui:weight': 'medium',
    'ui:widget': 'VariableDateTimeInputWidget',
    'ua:options': {
      variant: 'ghost',
      className: 'bg-secondary py-xs',
      fromYear: DEFAULT_FROM_YEAR,
      toYear: DEFAULT_TO_YEAR,
    },
    'ui:placeholder': 'dd/mm/yyyy',
    'ui:help': 'Choose the earliest selectable date',
  },
  maxDate: {
    'ui:titleClassName': 'text-primary',
    'ui:weight': 'medium',
    'ui:widget': 'VariableDateTimeInputWidget',
    'ua:options': {
      variant: 'ghost',
      className: 'bg-secondary py-xs',
      fromYear: DEFAULT_FROM_YEAR,
      toYear: DEFAULT_TO_YEAR,
    },
    'ui:placeholder': 'dd/mm/yyyy',
    'ui:help': 'Choose the latest selectable date',
  },
};
